import Color from '../Color.mjs'
import superMeta from '../_PSEUDO/metaPseudoNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'fkUserCode',
    name: '表外键',
    textProp: 'fkTitle',
    type: 'FK',
}
